<ayudas-with-thumbnails [tracking]="tracking" [sortByDate]="'asc'" [targetApp]="targetApp"></ayudas-with-thumbnails>
